var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',[_vm._l((_vm.options),function(option){return [_vm._t("item",function(){return [_c('a',{staticClass:"dropdown-item",attrs:{"role":"button"}},[_vm._t("default")],2)]},null,option)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }